<template>
<footer class="footer">
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-6">
                {{new Date().getFullYear()}} © CompAsia.
            </div>
            <div class="col-sm-6">
                <div class="text-sm-end d-none d-sm-block">
                    <!-- Develop by a CompAsia Sdn Bhd -->
                </div>
            </div>
        </div>
    </div>
</footer>
</template>
